import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { navigationEnd } from 'src/app/STORE/selectors/router.selector';

@Component({
  selector: 'vb-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false //NOSONAR
})
export class PageHeaderComponent {
  private store = inject(Store);
  appGlobalService = inject(AppGlobalService);

  pageName$: Observable<any> = this.store.select(navigationEnd);
  appListName = 'Application Overview';
}
